import {
  GET_N_PILOT_MEASUREMENTS_PDF_LOADING,
  GET_N_PILOT_MEASUREMENTS_PDF_FAILED,
  GET_N_PILOT_MEASUREMENTS_PDF_SUCCESS,
  STATUS_DEFAULT,
} from 'Redux/actions/types';

export const initialNPilotMeasurementPDFState = {
  status: STATUS_DEFAULT,
  data: [],
  errorCode: null,
};

export default (state = initialNPilotMeasurementPDFState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_N_PILOT_MEASUREMENTS_PDF_LOADING:
      return {
        ...state,
        data: payload,
        status: GET_N_PILOT_MEASUREMENTS_PDF_LOADING,
      };
    case GET_N_PILOT_MEASUREMENTS_PDF_SUCCESS:
      return {
        status: GET_N_PILOT_MEASUREMENTS_PDF_SUCCESS,
        data: payload,
        errorCode: null,
      };
    case GET_N_PILOT_MEASUREMENTS_PDF_FAILED:
      return {
        ...state,
        status: GET_N_PILOT_MEASUREMENTS_PDF_FAILED,
        errorCode: payload.errorCode,
      };
    default:
      return state;
  }
};
